import React from 'react';
import PropTypes from 'prop-types';
import _path from 'ramda/src/path';
import _clone from 'ramda/src/clone';

import Avatar from '../Avatar';
import GeneralUtility from '../../../utilities/generalUtility';
import resx from '../../../utilities/resx';
import { RESX_GLOBAL } from '../../../Constants';

const adsAdapter = (ad) => {
	const newAd = _clone(ad);
	newAd.ReblastId = ad.AdId;
	// parse and assign link
	const hrefRegex = /(?:href=['"])(.+?)(?:['"])/gim; // jshint ignore:line
	const match = hrefRegex.exec(ad.Message);
	if (match && match.length > 1) {
		newAd.Link = match[1]
	}
	return newAd;
};

function InFeedAd(props) {
	const data = adsAdapter(props.data);

	const RenderAttachmentImage = () => {
		const imgPath = _path(['Attachment', 'AttachmentImage', '1', 'Url'], data);
		const link = data.Link;

		if (imgPath && link) {
			return (
				<div className="reblast-listing-container has-associated-listing">
					<a className="seo-link reblast-listing-link" target="_blank" rel="noopener noreferrer" href={link}>
						<img src={imgPath} className="listing-image" alt="reblast listing photo" />
					</a>
				</div>
			);
		}
		if (imgPath && !link) {
			return (
				<div className="reblast-listing-container has-associated-listing">
					<img src={imgPath} className="listing-image" alt="reblast listing photo" />
				</div>
			);
		}
		return <React.Fragment></React.Fragment>;
	};

    const vidUrl = _path(['vidUrl'], GeneralUtility.generateVideoPlayerIframe(data.Message, true));

	return (
		<div className="single-reblast-container infeedad" data-ad-id={data.AdId}>
			<div className="single-block-container">
				<div className="message has-associated-listing ">
					<div className="item-content">

						<div className="re-reblast-user">
							<a
								href={`/${data.DomainUrl}`}
								title={`${data.FirstName}${resx(RESX_GLOBAL, 'PROFILE_BLONG_TO')}`}
								className="re-reblast-user-avatar profile-link"
							>
								<Avatar displayName={data.FirstName} size="sm" websiteId={data.WebsiteId} lazy={props.lazy} />
							</a>
                            <div className="re-reblast-user-info notranslate">
								<a
									href={`/${data.DomainUrl}`}
									title={`${data.FirstName}${resx(RESX_GLOBAL, 'PROFILE_BLONG_TO')}`}
									className="profile-link"
								>
									{data.FirstName} {data.LastName}
								</a>
								<ul className="re-reblast-user-details">
									<li className="reblast-firm-link re-idbar-detail-mobileview">
										<a
											href={`/agents/firm/${data.FirmUniqueName}/?_subjectName=${data.FirmName}`}
											className="firm-link"
										>
											{data.FirmName}
										</a>
									</li>
								</ul>
							</div>
						</div>

						<div className="re-reblast-content">
                            <p className="text reblast-message" dangerouslySetInnerHTML={{ __html: data.Message }}></p>
                            {vidUrl && <div className="re-reblast-video-container" dangerouslySetInnerHTML={{ __html: vidUrl }} />}
							{RenderAttachmentImage()}
                        </div>

					</div>
				</div>
			</div>
		</div>
	);
}

InFeedAd.propTypes = {
	data: PropTypes.object.isRequired,
	lazy: PropTypes.bool
};

export default InFeedAd;
